import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css, cx } from '@emotion/css'
import { paragraphTextCss } from '../../legacy-design-system/text'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { theme as deprecatedTheme } from '../../styled'

const betaTextCss = css`
  font-family: ${deprecatedTheme.fontFamilies.primaryCondensed};
  margin-left: 5px;
`

export function ToggleToNewDashboard({
  onClick
}: {
  readonly onClick: () => void
}) {
  return (
    <FormattedMessage id="action_dashboardViewNewDashboard">
      {(msg) => (
        <div
          data-testid="new-dashboard-button"
          onClick={onClick}
          className={cx(
            paragraphTextCss,
            css`
              border-radius: 10px;
              color: ${theme.color.white};
              background-color: ${theme.color.turquoise70};
              padding: 5px;
              cursor: pointer;
              position: absolute;
              right: 0;
              top: 0;
              margin: 10px 10px 0 0;
              padding: 2px 10px;
            `
          )}
        >
          {msg}
          <span className={betaTextCss}>
            <FormattedMessage id="action_dashboardViewNewDashboard_beta" />
          </span>
        </div>
      )}
    </FormattedMessage>
  )
}
